import {
  useExecutorRoleViewAuthorizationServiceContext,
  useLatestPreferencesContext,
} from '../context/contexts';
import { useMemoWithDeps } from '../context/hooks';
import { DataFields, DataFieldWithDataType } from '../types';
import { isHierarchical } from '../utils';
import { ExecutorRoleViewAuthorizationService } from './authorization/service';
import { Hasher } from './hasher';

export const useAllowedFilters = () => {
  const latestPreferences = useLatestPreferencesContext();
  return latestPreferences?.allowedFilters as DataFieldWithDataType[] | null;
};

const isFieldVisibleF =
  (authorizationService: ExecutorRoleViewAuthorizationService) =>
  (f: DataFieldWithDataType) => {
    if (isHierarchical(f)) {
      return authorizationService.canSeeField({
        dataType: f.dataType,
        dataField: `${f.dataField}_LEVEL_1` as DataFields,
      });
    } else {
      return authorizationService.canSeeField(f);
    }
  };

export const usePermittedFilters = () => {
  const authorizationService = useExecutorRoleViewAuthorizationServiceContext();
  const allowedFilters = useAllowedFilters();
  const isFieldVisible = isFieldVisibleF(authorizationService);
  const permittedFilters = useMemoWithDeps(
    '',
    () =>
      allowedFilters?.filter((f) => {
        const isFilterAllowed = authorizationService.canSeeFilter(f);
        return isFilterAllowed && isFieldVisible(f);
      }) ?? [],
    [Hasher.hash(allowedFilters)],
    [authorizationService]
  );
  return permittedFilters;
};
